enum languages {
	fr = 'fr',
	en = 'en'
}

export default languages